import { apiFetch } from '@ami/react/core';

export default class QuoteAttachmentPointCouplerInformation {
  constructor(json) {
    this.attachmentPointId = json.attachmentPointId;
    this.requiresCouplerDecision = json.requiresCouplerDecision;
    this.productGroupIdsPerType = Object.entries(
      json.productGroupIdsPerType
    ).map(([type, productGroupIds]) => ({ type, productGroupIds }));
  }

  static async calculateForSet(productIds) {
    const result = await apiFetch(
      `quote/coupler-decisions`,
      'POST',
      productIds
    );
    return result.map((x) => new QuoteAttachmentPointCouplerInformation(x));
  }
}
